module.exports = __webpack_public_path__ + "static/media/evolution_95.829b10d7.svg";